export default {

  home: {
    'test': { url: `${process.env.BASE_URL}glxp/UV_Grid.jpg`, options: [] },
    'Road_Sprite': { url: `${process.env.BASE_URL}glxp/Road_Sprite.png`, options: [] },
    'Hand_Sprite': { url: `${process.env.BASE_URL}glxp/Hand_Sprite.png`, options: [] },
    'Toilet-Paper': { url: `${process.env.BASE_URL}glxp/Toilet-Paper.png`, options: [] },
    'Splash_Sprite': { url: `${process.env.BASE_URL}glxp/Splash_Sprite.png`, options: [] },
    'Bad_hand_Sprite': { url: `${process.env.BASE_URL}glxp/Bad_hand_Sprite.png`, options: [] },
    'Cloud': { url: `${process.env.BASE_URL}glxp/Cloud.png`, options: [] },
  },


  audio: {
    "game-over": "/sound/game-over.mp3",
    "loop": "/sound/loop.mp3",
    "point": "/sound/point.mp3",
    "switch": "/sound/switch.mp3",
  },

}
